<template lang="pug">
    div
        Card.helper-card
            p(slot="title")
                Icon(type="md-pulse")
                |
                | Analytics
            div(slot="extra")
                Row
                  Col(span="20")
                      DateRangeSelector
                  Col(span="4")
                      SearchChartBtn(searchBtnIcon="md-refresh")
                // DashboardQueryFilter(
                //     :isWithGroupName="false"
                //     :isWithTags="false"
                //     :isWithServiceGroupName="false"
                //     :isWithAppProfileName="false"
                //     :isWithServerName="false"
                //     :isWithOrigin="false"
                //     )
            Row
                Col(span="24")
                    Card.dashBoardCard
                        LineChartWrapper(
                            style="width:100%"
                            :chartType="'reqlinechart'"
                            :chartDataSetLabel="['dashboard.requestCount']"
                            :titleDisplay="false"
                            :withCard="false"
                            :linePointRadius="[4]"
                            :linePointHoverRadius="[8]"
                            :linePointBackgroundColor="['white']"
                            :linePointBorderWidth="[3]"
                            :lineBorderColors="[colorScheme.blue.border]"
                            :linePointHoverBorderWidth="[5]"
                            :linePointHoverBorderColor="['rgba(152, 202, 235, 0.5)']"
                            :linePointHoverBackgroundColor="['white']"
                            :lineBackgroundGradientStops="[colorScheme.blue.gradientStops]"
                            :groupNames="[queryGroupName]")
                Col(span="24")
                    Card.dashBoardCard
                        LineChartWrapper(
                            style="width:100%"
                            :chartType="'cacheStatusLineChart'"
                            :chartDataSetLabel="['dashboard.dataCachedUsage', 'dashboard.dataServedUsage']"
                            :titleDisplay="false"
                            :numeralFormat="'0.00ib'"
                            :withCard="false"
                            :linePointRadius="[4, 4]"
                            :linePointHoverRadius="[8, 8]"
                            :linePointBackgroundColor="['white', 'white']"
                            :linePointBorderWidth="[3, 3]"
                            :lineBorderColors="[colorScheme.green.border, colorScheme.blue.border]"
                            :lineBackgroundGradientStops="[colorScheme.green.gradientStops, colorScheme.blue.gradientStops]"
                            :linePointHoverBorderWidth="[5, 5]"
                            :linePointHoverBorderColor="['rgba(152, 202, 235, 0.5)', 'rgba(152, 202, 235, 0.5)']"
                            :linePointHoverBackgroundColor="['white', 'white']"
                            :groupNames="[queryGroupName]")
    
</template>
<script>
import LineChartWrapper from "@/components/dashboard/LineChartWrapper";
import DashboardQueryFilter from "@/components/DashboardQueryFilterV2";
import DateRangeSelector from "@/components/FormItems/DateRangeSelector";
import SearchChartBtn from "@/components/SearchChartBtn";

import colorScheme from "@/data/colorScheme";
export default {
    name: "DashboardHelperCard",
    props: {},
    components: {
        LineChartWrapper,
        DashboardQueryFilter,
        DateRangeSelector,
        SearchChartBtn
    },
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            colorScheme: colorScheme,
            chartHeight: 280,
            direction: "horizontal"
        };
    },
    methods: {},
    mounted() {},
    computed: {
        // requestSummaryUri() {
        //     return this.$store.state.userData.privilege == "admin"
        //         ? "/admin/dashboard/requestsummary"
        //         : "/dashboard/requestsummary";
        // },
        queryGroupName() {
            return this.$store.state.queryGroupName == "all" ? "*" : this.$store.state.queryGroupName;
        }
    }
};
</script>

<style scoped>
/* .helper-card >>> .ivu-card-extra {
    position: absolute;
    right: 35px;
    top: 14px;
} */
</style>



// WEBPACK FOOTER //
// src/components/Home/DashBoardHelperCard.vue